// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"18f77e53","239":"49b12666","455":"ab3c61ac"}[chunkId] + ".chunk.js";
};